import { render, staticRenderFns } from "./SelectCus.vue?vue&type=template&id=71b9174c&scoped=true&"
import script from "./SelectCus.vue?vue&type=script&lang=js&"
export * from "./SelectCus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b9174c",
  null
  
)

export default component.exports